import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../entities/ErrorEntity";
import SearchResultEntity from "../entities/SearchResultEntity";
import ShiftEntity from "../entities/ShiftEntity";

export default interface ShiftRepository {
    searchShifts(query: string | undefined, page: number, itemsPerPage: number): Promise<Either<ErrorEntity, SearchResultEntity<ShiftEntity>>>;
    getShiftById(id: string): Promise<Either<ErrorEntity, ShiftEntity>>;
    deleteShift(id: string): Promise<Either<ErrorEntity, void>>;
    updateShift(shift: ShiftEntity): Promise<Either<ErrorEntity, ShiftEntity>>;
    createShiftWithSchedule(_:{scheduleId: string, date: Date, userId: string}): Promise<Either<ErrorEntity, ShiftEntity>>;
    reasignShift(_:{
        shiftId: string, newUserId: string, oldUserId: string, reason: string
    }): Promise<Either<ErrorEntity, ShiftEntity>>;
}

export const ShiftRepositoryName = "ShiftRepository";